import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c0o4zzgc: FaireBrandEntity = {
  token: "b_c0o4zzgc",
  type: "brand",
  name: "Hiouchi Jewels | Rose & Bolt Grateful Dead Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee0eebbca4ee605aab11d42e85bdbedca895d3dbb89e4521c9b14a4b83abf5fc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bad65b7d20fb4bf6f60d7e36d11a4fe7924a724f0e42dc3b74974c0b234aa170.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ee0eebbca4ee605aab11d42e85bdbedca895d3dbb89e4521c9b14a4b83abf5fc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bad65b7d20fb4bf6f60d7e36d11a4fe7924a724f0e42dc3b74974c0b234aa170.jpeg",
  location: "Evergreen, CO, USA",
  minimumOrderDollars: 276,
  rating: 5,
  reviewCount: 76,
  isInsider: true,
  description:
    "Hiouchi Jewels is Handcrafted Bohemian Jewelry & Home Decor Inspired by nature, and created with love.  Fun and affordable pieces feature motifs of moon phases, mountains, zodiac, feathers and sacred geometry, in a palette of natural crystals, stones, silver, and gold.  The collection is designed & created by Designer Sarah Lewis, based in Evergreen, Colorado.  Sarah designs for women like herself ~ Nature Loving, Fashion Forward, Modern Bohemians!  \n...\nRose & Bolt is Officially Licensed Grateful Dead Jewelry!  Launched in 2021, the collection has quickly grown a dedicated following & customer base, has been worn by members of the band on stage, and has been featured in the Rock & Roll Hall of Fame.  Sarah has fused her modern bohemian aesthetic with iconic Grateful Dead imagery.  As a lifelong deadhead, partnering with the legendary Grateful Dead is a dream-come-true for Sarah, and her love & passion for the music and community shines through the pieces! \n...\nFollow on Instagram @HiouchiJewels & @RoseAndBolt",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:08.665Z",
    importedBy: "entity-db-cli",
  },
};
